import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';

const FiltersThemeContext = createContext<FiltersTheme | null>(null);

export type FiltersTheme = {
  textColor: string;
  accentColor: string;
  // modalTextColor: string; // dont exist in requirements, but may be required later
  modalBackground: string;
};

type FiltersThemeProviderProps = PropsWithChildren<{ theme: FiltersTheme }>;

export function FiltersThemeProvider({
  children,
  theme
}: FiltersThemeProviderProps) {
  return (
    <FiltersThemeContext.Provider value={theme}>
      {children}
    </FiltersThemeContext.Provider>
  );
}

export function useFiltersTheme() {
  const context = useContext(FiltersThemeContext);
  if (context === null) {
    throw new Error(
      'useFiltersTheme must be used within a FiltersThemeProvider'
    );
  }
  return context;
}
